import FadeInWrapper from '@/components/Animated/FadeWrapper';
import { Panel } from '@/components/Layouts/ContentPanel';
import {
  artworkReactionsCSV,
  playerCardsCSV,
  playerCSV,
  sessionCSV,
  sessionRoundsCSV
} from '@/utils/metrics';
import { useState } from 'react';

export default function Metrics() {
  const firstOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    .toISOString()
    .split('T')[0];
  const today = new Date().toISOString().split('T')[0];

  const [startDate, setStartDate] = useState(firstOfMonth);
  const [endDate, setEndDate] = useState(today);

  const handlSessions = () => {
    sessionCSV(new Date(startDate), new Date(endDate));
  };

  const handleSessionRounds = () => {
    sessionRoundsCSV(new Date(startDate), new Date(endDate));
  };

  const handleDownloadPlayer = () => {
    playerCSV(new Date(startDate), new Date(endDate));
  };

  const handleDownloadPlayerCard = () => {
    playerCardsCSV(new Date(startDate), new Date(endDate));
  };

  const handleArtworkReactions = () => {
    artworkReactionsCSV(new Date(startDate), new Date(endDate));
  };

  return (
    <FadeInWrapper>
      <div className="mt-8">
        <Panel title="Export Raw Metrics Data">
          <div className="flex flex-col gap-6">
            {/* Date Range */}
            <div className="flex flex-col sm:flex-row gap-4 items-center">
              <div className="flex flex-col">
                <label htmlFor="start-date" className="mb-2 font-semibold text-gray-700">
                  Start Date
                </label>
                <input
                  type="date"
                  id="start-date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  max={endDate}
                  className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="end-date" className="mb-2 font-semibold text-gray-700">
                  End Date
                </label>
                <input
                  type="date"
                  id="end-date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  min={startDate}
                  className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            {/* Download Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="btn small" onClick={handlSessions}>
                Export Sessions
              </button>
              <button className="btn small" onClick={handleSessionRounds}>
                Export Session Rounds
              </button>
              <button className="btn small" onClick={handleDownloadPlayer}>
                Export Players
              </button>
              <button className="btn small" onClick={handleDownloadPlayerCard}>
                Export Player Cards
              </button>
              <button className="btn small" onClick={handleArtworkReactions}>
                Export Reactions
              </button>
            </div>
          </div>
        </Panel>
      </div>
    </FadeInWrapper>
  );
}
